import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { HistoriaClinica } from '../models';

@Injectable({
  providedIn: 'root',
})
export class HistoriaClinicaService {
  private collectionId = 'historia_clinica';
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  /**
   *getSedes
   * @returns
   */
  getHistoriasClinicas() {
    return databases
      .listDocuments(this.DATABASE_NAME, this.collectionId, [
        Query.orderDesc('$createdAt'),
      ])
      .then((response) => response.documents);
  }

  // Obtiene listado de historias clínicas de un especialista
  getHistoriasClinicasEspecialista(
    idEspecialista: string
  ): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.equal('idEspecialista', [idEspecialista]),
        Query.orderDesc('$createdAt'),
      ])
      .then((response) => response.documents);
  }

  // OBTIENE LISTADO DE HISTORIA CLINICAS QUE SEAN DIFERENTEA A N/A es decir las que se importaron del excel
  getHistoriasClinicasPaciente_na(
    idPaciente: string
  ): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.orderDesc('$createdAt'),
        Query.equal('idPaciente', [idPaciente]),
        Query.notEqual('idConsulta', 'n/a'),
      ])
      .then((response) => response.documents);
  }

  // Obtiene listado de hc de un paciente
  getHistoriasClinicasPaciente(idPaciente: string): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.orderDesc('$createdAt'),
        Query.equal('idPaciente', [idPaciente]),
      ])
      .then((response) => response.documents);
  }

  //Obtiene la última historia clinica de un paciente
  getHistoriasClinicasPacienteLast(idPaciente: string) {
    return databases
      .listDocuments(this.DATABASE_NAME, this.collectionId, [
        Query.orderDesc('$createdAt'),
        Query.equal('idPaciente', [idPaciente]),
        Query.select(['$id', 'idEspecialista.$id']),
        Query.limit(1),
      ])
      .then((response) => response.documents);
    // return databases
    //   .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
    //     Query.orderDesc('$createdAt'),
    //     Query.equal('idPaciente', [idPaciente]),
    //     Query.select(['$id', 'idEspecialista.$id']),
    //     Query.limit(1),
    //   ])
    //   .then((response) => response.documents);
  }
  /**
   * @getDocuments()
   * @param idPaciente
   * @returns
   */
  getHistoriasClinicasDateRIPS(
    fechaInicio: Date,
    FechaFin: Date
  ): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.greaterThanEqual('fCerrada', fechaInicio.toISOString()),
        Query.lessThanEqual('fCerrada', FechaFin.toISOString()),
        Query.equal('cerrada', true),
        Query.limit(500),
      ])
      .then((response) => response.documents);
  }

  getHistoriasClinicasDateEspRIPS(
    fechaInicio: Date,
    FechaFin: Date,
    IdEspecialista: string
  ): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.greaterThan('fCerrada', fechaInicio.toDateString()),
        Query.lessThan('fCerrada', FechaFin.toDateString()),
        Query.equal('cerrada', [true]),
        Query.equal('idEspecialista', [IdEspecialista]),
      ])
      .then((response) => response.documents);
  }

  getHistoriasClinicasDateEspSedeRIPS(
    fechaInicio: Date,
    FechaFin: Date,
    IdEspecialista: string,
    IdSede: string
  ): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.greaterThan('fCerrada', fechaInicio.toDateString()),
        Query.lessThan('fCerrada', FechaFin.toDateString()),
        Query.equal('cerrada', [true]),
        Query.equal('idEspecialista', [IdEspecialista]),
      ])
      .then((response) => response.documents);
  }
  getHCfromIdCita(IdCita: string): Promise<HistoriaClinica[]> {
    return databases
      .listDocuments<HistoriaClinica>(this.DATABASE_NAME, this.collectionId, [
        Query.equal('idCita', [IdCita]),
      ])
      .then((response) => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument_org(data) {
    const documentId = ID.unique();
    console.log('data create consulta', data);
    console.log('data id : ', documentId);
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      documentId,
      data
    );
  }

  async createDocument(data) {
    const timestamp = Date.now();
    const uniqueId = `${timestamp}-${ID.unique()}`;

    console.log('data create consulta', data);
    console.log('data id : ', uniqueId);

    try {
      const result = await databases.createDocument(
        this.DATABASE_NAME,
        this.collectionId,
        uniqueId,
        data
      );
      console.log('Documento creado exitosamente:', result);
      return result;
    } catch (error) {
      if (error.code === 409) {
        console.log('ID duplicado detectado, generando nuevo ID...');
        // Si hay un conflicto, intentamos una vez más con un nuevo ID
        const newDocumentId = ID.unique();
        const result = await databases.createDocument(
          this.DATABASE_NAME,
          this.collectionId,
          newDocumentId,
          data
        );
        console.log('Documento creado exitosamente con nuevo ID:', result);
        return result;
      }
      console.error('Error al crear documento:', error);
      throw error;
    }
  }

  updateDocument(idHistoriaClinica, data) {
    data.$databaseId = undefined;
    data.$collectionId = undefined;
    return databases.updateDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idHistoriaClinica,
      data
    );
  }

  // Obtiene Historia Clínica por id
  getHistoriaClinica(idDocument: string) {
    return databases
      .getDocument(this.DATABASE_NAME, this.collectionId, idDocument)
      .catch((error) => {
        return error;
      });
  }
}
